import React from "react";
import { Link } from "react-router-dom";
import { paths } from "../routing/paths";
import logoAleph from "../assets/logo-aleph.png";

/*
 * Redesigned footer — navy band, brand line + link groups.
 * The newsletter + Chai Club band is a separate homepage zone (Phase 2);
 * this footer stays lean site-wide.
 */

const GROUPS = [
  {
    title: "Learn",
    links: [
      { label: "Daily Tanya", href: paths.dailyTanya() },
      { label: "Hayom Yom", href: paths.dailyHayomYom() },
      { label: "This week's Parsha", href: paths.weeklyParsha() },
      { label: "Latest classes", href: paths.latestClasses() },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "Ask a question", href: paths.askQuestion() },
      { label: "Contact us", href: paths.contact() },
      { label: "About", href: paths.about() },
      { label: "Live", href: paths.live() },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Donate", href: paths.donations() },
      { label: "Chai Club", href: paths.chaiClub() },
      { label: "Privacy policy", href: paths.privacy() },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="ic-scope bg-ic-navy font-sans mt-auto">
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 py-10 sm:py-14 flex flex-col gap-10">
        <div className="flex flex-col md:flex-row gap-10 md:gap-16">
          <div className="flex flex-col gap-3 md:max-w-[320px]">
            <div className="flex items-center gap-3">
              <img src={logoAleph} alt="" className="flex-shrink-0 w-10 h-10 rounded-full" />
              <span className="text-ic-offwhite text-[18px] font-bold leading-7">Inside Chassidus</span>
            </div>
            <p className="m-0 text-[14px] leading-5 text-ic-lightGray">
              Over 15,000 audio and video classes on Chabad Chassidus by Rabbi Yossi Paltiel.
            </p>
          </div>
          <div className="flex flex-wrap gap-10 sm:gap-16">
            {GROUPS.map((g) => (
              <div key={g.title} className="flex flex-col gap-2 min-w-[140px]">
                <span className="text-[12px] leading-4 font-bold tracking-[0.5px] uppercase text-ic-sky">
                  {g.title}
                </span>
                <ul className="m-0 p-0 list-none flex flex-col gap-1">
                  {g.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        to={l.href}
                        className="inline-block text-[16px] font-semibold leading-6 text-ic-offwhite no-underline py-2.5 transition-colors duration-150 ease-out hover:text-ic-sky hover:no-underline"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between">
          <span className="text-[14px] leading-5 text-ic-lightGray">
            A project of Inside Chassidus ·{" "}
            <a
              href="mailto:Info@insidechassidus.org"
              className="text-ic-lightGray underline hover:text-ic-sky inline-flex items-center py-3 -my-3 min-h-[44px]"
            >
              Info@insidechassidus.org
            </a>
          </span>
          <span className="text-[12px] leading-4 text-ic-slate">
            © {new Date().getFullYear()} Inside Chassidus
          </span>
        </div>
      </div>
    </footer>
  );
}
